<app-banner [loading]="loading" [info]="true" [heading]="heading" [subHeading]="'View revalidation records'">


  <div class="toolbar-content">

    @if (!layout.state.fullscreen) {
      <button (click)="layout.setFullscreen(true)" aria-label="Maximise" class="btn btn-back">
        <i class="fa fa-window-maximize"></i>
        <span>maximise</span>
      </button>
    }

    @if (layout.state.fullscreen) {
      <button (click)="layout.setFullscreen(false)" aria-label="Maximise" class="btn btn-back">
        <i class="fa fa-window-restore"></i>
        <span>restore</span>
      </button>
    }

    <!-- <button (click)="toggleSearch()" aria-label="Search for requests by registration number" class="btn">
    <i class="fa fa-search"></i>
    <span>search</span>
  </button>-->

</div>

</app-banner>

<app-collapsible [trigger]="!searchVisible">
  <div class="content form-inline " style="padding: 20px;">

    <div class="form-group reg-number p-2">
      <!--<input #regNumber placeholder="Search Reg Number..." [(ngModel)]="searchCriteria.regNumber"  type="text"
      name="regNumber" class="form-control " />-->
      <label style="padding-right: 10px;">Search by renewal date:  </label>
      <app-utc-date-picker [error]="error" name="revalidationSelected" [(ngModel)]="searchCriteria.renewalDate" (ngModelChange)="dateChange($event)" #renew="ngModel"></app-utc-date-picker>
      <app-collapsible [trigger]="status.touched && renew.error?.invalid">
        <p class="form-error">
          renewal date is manditory
        </p>
      </app-collapsible>
      <button class="btn btn-primary ml-2" [disabled]="!searchCriteria.renewalDate"
      (click)="search()">Search</button>
      <button class="btn btn-default ml-2" (click)="clearSearch()">Clear</button>
    </div>

    <div class="form-group p-2">
      <span style="font-weight: 600;">Search by current status : </span>
      <select #status="ngModel" style="cursor: pointer;" placeholder= "'choose status'" class="form-control" name="currentStatus"
        [(ngModel)]="searchCriteria.status" (ngModelChange)="filter($event)" [disabled]="!(items && items.length > 0)">
        <option value="" disabled>Choose status </option>
        @for (item of RevalidationStatus | keys; track item) {
          <option [value]="item.value">
            {{ item.value | caseSplit }}
          </option>
        }
      </select>
    </div>
  </div>
</app-collapsible>


@if (items.length > 0) {
  <div class="content no-boxes fadein" style="padding:0">
    <table class="table more-details" style="font-size: 0.9em;">
      <thead>
        <tr>
          <th style="padding-left: 30px;"> Registration no </th>
          <th> Registrant name </th>
          <th> Submission deadline </th>
          <th> Current status </th>
          <th> Registration status </th>
          <th> Dual registrant </th>
          <th> Under investigation </th>
        </tr>
      </thead>
      <tbody>
        @for (item of items; track item; let i = $index) {
          <tr
            >
            <td style="padding-left: 30px;"> {{ item.registrationNumber}} </td>
            <td> {{ item.forenames + '' + item.surname }} </td>
            <td> {{ item.submissionDeadline | utcDate }} </td>
            <td> {{ (RevalidationStatus[item.revalidationStage] | caseSplit) || 'Not Submitted' }} </td>
            <td> {{ (RegistrationStatus[item.registrationStatus] | caseSplit) || 'Un known' }} </td>
            <td> {{ item.dualRegistration === true ? 'Yes' : 'No'}} </td>
            <td> {{ item.underInvestigation === true ? 'Yes' : 'No' }} </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
} @else {
  <div class="content no-boxes fadein mrgn-btm-50 pad-left-30">
    <div class="no-data">
      No records found
    </div>
  </div>
}


